import { QueryErrorBanner } from '@/components/feedback/query-error';

interface FeesErrorBannerProps {
  message: string;
  onRetry: () => void;
}

/**
 * @deprecated Superseded by the shared QueryErrorBanner — this
 * component originally hand-rolled the red-div Variant B markup that
 * QueryErrorBanner now owns. Kept as a thin re-export because
 * custom-trading-fees-panel.tsx, coin-fees-panel.tsx, and fee-exclusions-panel.tsx
 * import it and are out of scope for this wave; migrate those call sites to
 * QueryErrorBanner directly and delete this wrapper.
 */
export const FeesErrorBanner = ({ message, onRetry }: FeesErrorBannerProps) => <QueryErrorBanner message={message} onRetry={onRetry} />;
FeesErrorBanner.displayName = 'FeesErrorBanner';
